import { render, staticRenderFns } from "./AddPatient.vue?vue&type=template&id=561fc4aa&"
import script from "./AddPatient.vue?vue&type=script&lang=ts&"
export * from "./AddPatient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports